// Loads the Chatwoot website widget SDK script and resolves once it's ready.
// https://www.chatwoot.com/docs/product/channels/live-chat/sdk/setup

import { stripTrailingSlashes } from "@utils/index";

let widgetPromise = null;

export const loadChatwootWidget = ({ baseUrl, websiteToken, locale = "ru" }) => {
    if (widgetPromise) {
        return widgetPromise;
    }

    if (typeof document === "undefined" || !baseUrl || !websiteToken) {
        return Promise.resolve(null);
    }

    window.chatwootSettings = { locale };

    widgetPromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = `${stripTrailingSlashes(baseUrl)}/packs/js/sdk.js`;
        script.async = true;
        script.defer = true;
        script.onerror = () => resolve(null);
        script.onload = () => {
            window.addEventListener("chatwoot:ready", () => resolve(window.$chatwoot), { once: true });
            window.chatwootSDK?.run({ websiteToken, baseUrl });
        };
        document.body.appendChild(script);
    });

    return widgetPromise;
};

// Opens the chat bubble, loading the widget first if it is not ready yet.
export const openChatwootChat = () => loadChatwootWidget({
    baseUrl: import.meta.env.VITE_CHATWOOT_BASE_URL,
    websiteToken: import.meta.env.VITE_CHATWOOT_WEBSITE_TOKEN,
}).then((instance) => instance?.toggle("open"));

export default {};
